import { Component, Inject, OnInit } from '@angular/core';
import { DarkModeService } from './core/services/dark-mode.service';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/presentationals/loader/loader.component';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import DeviceHelper from './core/helpers/device.helper';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from './core/services/authentication.service';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

// Use local script to avoid CSP violations
(window as any).pdfWorkerSrc = 'assets/scripts/pdf.worker.min.js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [LoaderComponent, RouterOutlet, MatIconModule],
})
export class AppComponent implements OnInit {
  constructor(private readonly darkModeService: DarkModeService,
    private readonly translateService: TranslateService,
    private readonly authenticationService: AuthenticationService,
    private readonly dateAdapter: DateAdapter<any>,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private readonly document: Document) {

      ['AG', 'AI', 'AR', 'BE', 'BL', 'BS', 'FR', 'GE', 'GL', 'GR', 'JU', 'LU', 'NE', 'NW', 'OW', 'SG', 'SH', 'SO', 'SZ', 'TG', 'TI', 'UR', 'VD', 'VS', 'ZG', 'ZH']
      .forEach((canton) => {
        iconRegistry.addSvgIcon(
          canton,
          sanitizer.bypassSecurityTrustResourceUrl(`assets/images/flags/${canton.toLowerCase()}.svg`)
        )
      })      
  }

  ngOnInit(): void {
    this.darkModeService.initialize();

    // Change language of date picker
    this.translateService.onLangChange.subscribe(() => {
      this.dateAdapter.setLocale(this.translateService.currentLang);
    });

    if (DeviceHelper.isMobileDevice()) {
      this.document.body.classList.add('mobile-device');
    }

    // Load protected translations once user is authenticated
    const authenticatedSubscription = this.authenticationService.authenticated$
      .subscribe(model => {
        if(model) {
          if(!this.authenticationService.getIsTokenRestored()) {
            this.translateService.reloadLang(this.translateService.currentLang)
            .subscribe(() => {
              authenticatedSubscription.unsubscribe();
            });
          }
        }
      });
  }
}
